import apiFF from 'app/services/fastfrete-api/apiFF';
import { caminhoDoPainelDeOfertas, responderAoPainelDeOfertas } from './respostas';

const comAdaptadorSimulado = (configuracao) => (caminhoDoPainelDeOfertas(configuracao.url) === null
    ? configuracao
    : { ...configuracao, adapter: responderAoPainelDeOfertas });

export const instalarMocksDoPainelDeOfertas = () => {
    apiFF.interceptors.request.use(comAdaptadorSimulado);
};
